import type { EntityConfig } from '../types'

export const creditGrantEntity: EntityConfig = {
  id: 'credit-grant',
  displayName: 'Credit Grant',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'pending', label: 'Pending' },
      { value: 'expired', label: 'Expired' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'pending', label: 'Pending', color: 'warning' },
      { value: 'expired', label: 'Expired', color: 'error' },
    ],
    mappings: {
      all: ['active', 'pending', 'expired'],
      active: ['active'],
      pending: ['pending'],
      expired: ['expired'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
  },
  uiFilterFields: ['status']
}
